import { render } from "./ListingDetail.vue?vue&type=template&id=70bb36a5&scoped=true"
import script from "./ListingDetail.vue?vue&type=script&lang=js"
export * from "./ListingDetail.vue?vue&type=script&lang=js"

import "./ListingDetail.vue?vue&type=style&index=0&id=70bb36a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bb36a5"]])

export default __exports__